<template>
  <button type="button" class="booking-shared-action" title="Print" @click.stop="onPrint">
    <feather-icon icon="PrinterIcon" svgClasses="h-4 w-4" />
    <span>Print</span>
  </button>
</template>

<script>
import { printBooking } from '@/utils/booking/printBooking'

export default {
  name: 'BookingPrintButton',
  props: {
    booking: {
      type: Object,
      default: null
    },
    module: {
      type: String,
      required: true
    }
  },
  methods: {
    onPrint () {
      if (!this.booking) {
        this.$vs.notify({ title: 'Print', text: 'Booking details are not available to print.', color: 'warning' })
        return
      }
      try {
        printBooking(this.booking, this.module)
      } catch (error) {
        this.$vs.notify({ title: 'Print', text: error.message || 'Unable to print this booking.', color: 'warning' })
      }
    }
  }
}
</script>

<style scoped>
.booking-shared-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid currentColor;
  background: transparent;
  color: inherit;
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  line-height: 1.2;
}
.booking-shared-action:hover {
  opacity: 0.8;
}
</style>
